import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  createdAutoTemplate: {},
  autoTemplateDraftUuid: null,
};

const autotemplateSlice = createSlice({
  name: 'autotemplateSlice',
  initialState,
  reducers: {
    createdAutoTemplateSlice: (state, { payload }) => {
      state.createdAutoTemplate = payload;
    },
    autoTemplateDraftUuidSlice: (state, { payload }) => {
      state.autoTemplateDraftUuid = payload;
    },
  },
});

const { actions, reducer } = autotemplateSlice;

export const { createdAutoTemplateSlice, autoTemplateDraftUuidSlice } = actions;

export default reducer;
